export async function getManagerSettings({ token, userId, themeName }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getManagerSettings`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      ...(themeName != null && String(themeName).trim() !== "" ? { themeName } : {}),
    }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || "Failed to fetch manager settings");
  }
  if (data && data.success === false) {
    throw new Error(data.message || "Failed to fetch manager settings");
  }
  return data;
}

